import { useEffect } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { initLenis } from "@/lib/scroll";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Manifesto from "@/components/site/Manifesto";
import Services from "@/components/site/Services";
import Projects from "@/components/site/Projects";
import About from "@/components/site/About";
import WhyUusimaa from "@/components/site/WhyUusimaa";
import InstagramStrip from "@/components/site/InstagramStrip";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import MobileBar from "@/components/site/MobileBar";

function App() {
  useEffect(() => {
    const lenis = initLenis();
    return () => lenis.destroy();
  }, []);

  return (
    <div className="App bg-void text-neutral-100 antialiased">
      <div className="grain-overlay" aria-hidden="true" />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Services />
        <Projects />
        <About />
        <WhyUusimaa />
        <InstagramStrip />
        <Contact />
      </main>
      <Footer />
      <MobileBar />
      <Toaster position="top-center" theme="dark" toastOptions={{ style: { background: "#181B20", border: "1px solid rgba(255,255,255,0.12)", color: "#F9FAFB" } }} />
    </div>
  );
}

export default App;
